'use client';

import { useEffect } from 'react';
import Script from 'next/script';

import { getMarketingScriptVersion } from './getMarketingScriptVersion';

interface Props {
  isEnabled: boolean;
}

export const FacebookPixel = (props: Props) => {
  const { isEnabled } = props;

  const ejectFacebookPixel = () => {
    const facebookPixelSnippet = document.getElementById(
      'facebook-pixel-snippet',
    );
    const facebookPixelScript = document.getElementById(
      'facebook-pixel-script',
    );

    facebookPixelSnippet?.remove();
    facebookPixelScript?.remove();
  };

  useEffect(() => {
    if (isEnabled) return;

    ejectFacebookPixel();
  }, [isEnabled]);

  useEffect(() => {
    return () => {
      ejectFacebookPixel();
    };
  }, []);

  if (!isEnabled) return null;

  return (
    <Script
      id="facebook-pixel-snippet"
      key="facebook-pixel-snippet"
      defer
      strategy="lazyOnload"
      type="text/javascript"
      src={`/g/scripts/marketing/facebook-pixel.js?v=${getMarketingScriptVersion()}`}
    />
  );
};
